<template>
  <el-tooltip
    :effect="effect"
    :content="content"
    :placement="placement"
    :disabled="!isOverflow"
  >
    <div
      class="text-overflow-container"
      :style="boxStyle"
      @mouseenter="checkOverflow"
    >
      {{ content }}
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: "TextOverflowTooltip",
  props: {
    // 需要展示的文本内容
    content: {
      type: [String, Number],
      default: "",
    },
    // 限制展示的最大行数，默认为 1 行
    lines: {
      type: Number,
      default: 1,
    },
    placement: {
      type: String,
      default: "top",
    },
    effect: {
      type: String,
      default: "dark",
    },
  },
  data() {
    return {
      isOverflow: false, // 标识文本是否溢出
    };
  },
  computed: {
    boxStyle() {
      return {
        "-webkit-line-clamp": this.lines,
        "line-clamp": this.lines,
      };
    },
  },
  methods: {
    checkOverflow(event) {
      const el = event.target;
      // 判断实际内容的高度/宽度是否超出了容器的可视高度/宽度
      const isOverflowing =
        el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;

      this.isOverflow = isOverflowing;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-overflow-container {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
